import { FC } from 'react';
import cn from 'classnames';
import { isVideoUrl } from 'base/utils/file';
import Image from '@base/lib/ThemeImage';
import { ThemeImageProps } from '@base/lib/ThemeImage/interface';
import PureVideo, { DEFAULT_CONTROL_SIZE } from '@base/lib/PureVideo';

export type { LinkProps } from 'next/link';

type PreviewThumbProps = {
    url: string;
    width: number; // 仅用于控制图片加载
    height: number; // 仅用于控制图片加载
    onClick?: () => void;
    className?: string;
    alt?: string;
    waitLoad?: boolean;
    fit?: ThemeImageProps['fit'];
    fixed?: ThemeImageProps['fixed'];
};

export const PreviewThumb: FC<PreviewThumbProps> = props => {
    const {
        className,
        url,
        alt,
        onClick,
        width,
        height,
        waitLoad,
        fit = 'cover',
        fixed
    } = props;

    return (
        <div
            className={cn(
                className,
                'thumb pointer'
            )}
            onClick={onClick}
        >
            {
                isVideoUrl(url)
                    ? (
                        <PureVideo
                            width={width}
                            height={height}
                            src={url}
                            fit={fit}
                            control={{
                                size: Math.min(width / 2.5, DEFAULT_CONTROL_SIZE)
                            }}
                            disablePlay
                        />
                    )
                    : (
                        <Image
                            fixed={fixed}
                            src={url}
                            alt={alt}
                            width={width}
                            height={height}
                            fit={fit}
                            background={false}
                            waitLoad={waitLoad}
                        />
                    )
            }
        </div>
    )
};

export default PreviewThumb;